import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { LoginGQL } from 'src/app/generated/graphql';
import { AuthService } from 'src/app/services/auth/auth.service';
import { AlertService } from 'src/app/services/util/alert.service';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
    selector: 'app-login',
    templateUrl: './app.login.component.html',
    styleUrls: ['./app.login.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule]
})
export class AppLoginComponent implements OnInit, AfterViewInit {
  @ViewChild('input') input: ElementRef<HTMLInputElement> | undefined;
  loginForm: FormGroup;
  loading: boolean = false;
  returnUrl: string | null | undefined;
  token: string | null | undefined;

  constructor(
    private router: Router,
    private loginQuery: LoginGQL,
    private authService: AuthService,
    private fb: FormBuilder,
    private alert: AlertService,
    private route: ActivatedRoute
  ) {
    this.token = this.route.snapshot.queryParamMap.get('token');
    
    if (this.token) {
      this.authService.saveSession(this.token);
    }

    this.loginForm = this.fb.group({
      usuario: [undefined, Validators.required],
      senha: [undefined, Validators.required]
    });
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    if (this.authService.getSession()) {

      if  (this.returnUrl) {
        this.router.navigate([this.returnUrl]);
      } else {
        this.router.navigate(['/'], {
          replaceUrl: true
        });
      }
    };
  }

  ngAfterViewInit() {
    this.input?.nativeElement.focus();
  }

  login() {
    if (!this.loginForm.valid) {
      return;
    };

    this.loading = true;
    this.loginQuery.fetch({
      data: this.loginForm.value
    }).pipe(
      finalize(() => {
        this.loading = false
      })
    ).subscribe({
      next: rs => {
        const token = rs.data.login?.token ?? '';
        this.authService.saveSession(token);
        this.router.navigate([this.returnUrl ? this.returnUrl : '/'], {
          replaceUrl: true
        });
      },
      error: err => {
        this.alert.showGQLError(err);
      }
    });
  }

}
